export type AppAccordionTokens = {
	panelGap: string;
};

export default {
	panelGap: '8px',
} satisfies AppAccordionTokens;
